<div class="collapse fixed-top" id="navbarToggleExternalContent">
  <div class="bg-inverse p-4">
    <div class="btn-box">
      <mat-icon class="menu_btn" data-toggle="collapse" data-target="#navbarToggleExternalContent">menu</mat-icon>
    </div>
    <h4 class="text-white menu-title">VISUAL MEDIA LAB</h4>
    <div class="list-group">
      <a routerLink="/main/info" class="list-group-item list-group-item-action">ABOUT</a>
      <a routerLink="/main/people" class="list-group-item list-group-item-action">PEOPLE</a>
      <a routerLink="/main/area" class="list-group-item list-group-item-action">RESEARCH</a>
      <a routerLink="/main/international" class="list-group-item list-group-item-action">PUBLICATIONS</a>
      <a routerLink="/main/news" class="list-group-item list-group-item-action">NEWS & EVENT</a>
      <a routerLink="/main/seminar" class="list-group-item list-group-item-action">ARCHIVE</a>
    </div>
  </div>
</div>
<nav class="navbar navbar-light fixed-top" id="nav-animation">
  <mat-icon class="menu_btn" data-toggle="collapse" data-target="#navbarToggleExternalContent">menu</mat-icon>

  <a routerLink="/" class="indexpage-nav-btn navbar-brand">
    <img src='./../../assets/Contents/imgs/logo.svg' height="66" id="logo-animation">
  </a>
  <ul class="nav navbar-nav">
    <li class="menu01 nav-item">
      <a class="nav-link" routerLink="/main/info">ABOUT</a>
    </li>

    <li class="menu01 nav-item">
      <a class="nav-link" routerLink="/main/people">PEOPLE</a>
    </li>

    <li class="menu01 nav-item">
      <a class="nav-link" routerLink="/main/area">RESEARCH</a>
    </li>
    <li class="menu01 nav-item">
      <a class="nav-link" routerLink="/main/international">PUBLICATIONS</a>
    </li>
    <li class="menu01 nav-item">
      <a class="nav-link" routerLink="/main/news">NEWS & EVENT</a>
    </li>
    <li class="menu01 nav-item">
      <a class="nav-link" routerLink="/main/seminar">ARCHIVE</a>
    </li>
  </ul>
  <ul class="search-nav">
    <li class="search">
      <img class="search_btn" fill-opacity="0" width="30px">
      <input id="searchBar">
    </li>
  </ul>
</nav>

<div class="main no-gutters col-sm" style="flex-flow: column">
  <!-- <div class="col-sm"> -->

    <div class="row header">

      <div class="video-background">
        <div class="video-foreground">
          <iframe src="https://www.youtube.com/embed/iEgCiteVzu8?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1&playlist=iEgCiteVzu8" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>

      <!-- <video autoplay loop muted id="video-bg" poster="./assets/imgs/home_mainImg.jpg" src="https://www.youtube.com/embed/Ewb_YBTEkZ0?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1&playlist=Ewb_YBTEkZ0"> -->
      <!-- </video> -->

      <div class="title text-center">
        <div class="display-2 title-text">VISUAL MEDIA LAB</div>
        <h3 class="title-text">Where Creativity Meets Technology</h3>
        <p class="title-text">focuses on developing fundamental computer graphics technology and software applications specifically for the creation
          of movie visual effects and animated films. Since its foundation in 2006, VML has emphasized both R&D and contens
          production as a core part of lab activity. About 20 Ph.D. and master program students along have published numerous
          papers at premium graphics conferences and showcased animations at international computer animated festivals. The
          close relationship with industry has allowed VML to contribute its technology to recently released movies.</p>



      </div>

      <mat-icon id="arrowBtn" (click)="moveTo('arrowBtn')" class="title-arrow text-center">keyboard_arrow_down</mat-icon>

    </div>

    <div class="row content" id="nav-trigger">

      <div id="arrowBtnPlace" class="Heading col-sm-12 text-center" scrollSpy>
        <h1 routerLink="/main/area" >Reseach Area</h1>
        <p class="section-desc">The main research area includes motion and facial animation of virtual chararcter, immersive display system and human
          interaction system</p>
      </div>
      <div class="card-deck-wrapper col-sm-12">
        <div class="card-deck">
          <div class="ie11-issue">

            <div (click)='navigateTo(team.id)' *ngFor="let team of teams$ | async" class="card pad card-area  ">

              <img class="img-fluid card-img-top" [srcset]=" imgPath + team.smallimg" [src]=" imgPath + team.img">
              <div class="card-block">
                <h4 class="card-title">{{team.shortname}}</h4>
                <!-- <p class="card-text">{{team.fullname}}</p> -->
                <p class="card-text">
                  <small class="text-muted">{{team.area}}</small>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <div class="col-sm-12 news">
          <div class="Heading text-center col-sm-12">
            <h1 routerLink="/main/international" >Recent Publications</h1>
            <p class="section-desc">The main research area includes motion and facial animation of virtual chararcter, immersive display system and
              human interaction system</p>
          </div>

          <div class="">

            <div (click)='navigateTo(pub.id, 1)' *ngFor="let pub of publications$ | async" class="card issueCard pad pub-pad">

              <!-- <img class="news-img card-img-top img-fluid" [srcset]="pub.img ? imgPath + pub.img : defaultImage" [src]=" imgPath + pub.img"> -->
              <img *ngIf="pub.img" default="./../../assets/Contents/imgs/no_image.jpg" class="news-img card-img-top img-fluid" [srcset]="imgPath + pub.img" [src]=" imgPath + pub.img">

          <!-- <img default="./../../../../assets/Contents/imgs/no_image.jpg"
              [srcset]= 'imgPath + publication.img + " 800w, " +
                        imgPath+ publication.smallimg + " 300w "'
              sizes="(min-width:990px) 300px, 800px"> -->
              <div class="card-block">
                <h4 class="card-title">{{pub.title}}</h4>
                <p class="card-text desc">{{pub.conference}}</p>

              </div>
            </div>

          </div>
        </div>

        <div class="col-sm-12 news">
          <div class="Heading text-center col-sm-12">
          <h1 routerLink="/main/news" >Recent News and Media</h1>
            <p class="section-desc">Recent news related to Visual Media Lab</p>
          </div>

          <div class="card-columns">
            <div *ngFor="let issue of issues | async" class="card issueCard" (click)='navigateTo( issue.type, 2)' >
              <img class="news-img card-img-top img-fluid" [src]="imgPath + issue.img" [srcset]="issue.img ?  imgPath + issue.img : defaultImage  ">
              <div class="card-block">
                <h4 class="card-title">{{issue.title}}</h4>
                <p class="card-text desc">{{issue.desc}}</p>
                <p class="card-text">
                  <small class="text-muted">{{issue.date | dateChange}}</small>
                </p>
              </div>
            </div>
          </div>
        </div>


        <div class="col-sm-12 news">
          <div class="Heading text-center col-sm-12">
            <h1 routerLink="/main/partners">Partners</h1>
            <p class="section-desc">Partners with the Visual Media Lab</p>
          </div>


          <div class="partners-columns">


            <div *ngFor="let partner of partners$ | async" class="partner-img-box">
              <a [href]='partner.link' class="partner-img">
                <img class="partner-img" default='./../../assets/Contents/imgs/no_image.jpg' [srcset]=" imgPath + partner.logo" [src]=" imgPath + partner.logo">
              </a>
              <!-- <img class="partner-img" [srcset]=" imgPath + partner.logo" [src]=" imgPath + partner.logo"> -->
            </div>
          </div>

          <div class="partners-more text-center">
            <a routerLink="/main/partners" class="myButton">MORE PARTNERS</a>
          </div>

        </div>




      </div>


    </div>

  <!-- </div> -->
</div>


<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-sm-12 right-border">
        <div class="footer-about">
          <h2 class="footer-title">About Us</h2>
          <p class="menu02">The Visual Media Lab (VML) in the Graduate School of Culture Technology (GSCT) at KAIST is where technology and creativity meet.
            Since its foundataion in 2006, VML has committed to advancing computer graphics technologies.
            Recently, it has focused on developing innovative solutions for character and facial animation, as well as image and video generation and editing.
            <br>
            <br>
            VML is renowned for its collaborative and open academic environment, encouraging students from various disciplines to engage, question, and innovate together.
            About 20 Ph.D. and Master program researchers have published numerous papers at premier graphics and vision conferences.
            The close relationship with the industry has allowed VML to contribute its technology to movies and new media platform.
          </p>
        </div>
        <div class="copyright hidden-sm hidden-xs">
          <p>Copyrights &copy; 2017
            <a href="http://vml.kaist.ac.kr/" title="">Visual Media Lab, KAIST</a>. All Right Reserved.</p>
          <p>Developed By :
            <a href="http://jundongpark.com/" title="">Jundong</a>
            <a href="https://vml.kaist.ac.kr/main/people/person/19" title="">Jungeun</a>
            <a href="https://vml.kaist.ac.kr/main/people/person/12" title="">Bumki</a>
          </p>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="col-md-6 col-sm-6 ">
          <div class="navigation">
            <h2 class="footer-title">Navigation</h2>
            <ul class="list-unstyled">
              <li class="">
                <a class="" routerLink="/main/info">ABOUT</a>
              </li>
              <li class="">
                <a class="" [routerLink]="['/main/people']">PEOPLE</a>
              </li>
              <li class="">
                <a class="" routerLink="/main/area">RESEARCH</a>
              </li>
              <li class="">
                <a class="" routerLink="/main/news">NEWS & EVENT</a>
              </li>
              <li class="">
                <a class="" routerLink="/main/seminar">ARCHIVE</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="contact-info">
            <h2 class="footer-title">Contact Info</h2>
            <div class="single">
              <mat-icon class="md-light">location_on</mat-icon>
              <p>Visual Media Lab, KAIST
                <br>373-1 Guseong-dong, Yuseong-gu Daejeon, 305-701, Republic of Korea
              </p>
            </div>
            <div class="single">
              <mat-icon class="md-light">phone</mat-icon>
              <p>+82-42-350-5918</p>
            </div>

            <div class="single">
              <mat-icon class="md-light">email</mat-icon>
              <p>visualmedia@kaist.ac.kr</p>
            </div>

            <div class="single">
              <mat-icon class="md-light">movie</mat-icon>
              <a href="https://www.youtube.com/user/VMLKAIST" style="font-size: 13px; color: rgba(255, 255, 255, 0.6);">Youtube Channel</a>
            </div>

          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</footer>


// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/home/home.component.html